/* eslint-disable max-params */
import interceptor from './interceptor';
import { apiUrl } from '../environment/index';

export const leadPartnersGetAllReferrals = (
  page = 1,
  startDate,
  endDate,
  keyword = '',
  limit = 25,
  sortBy = 'createdAt',
  sortDirection = 'desc'
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(`${apiUrl}/lead_partners/referral`, {
    params: {
      page,
      startDate,
      endDate,
      keyword,
      limit,
      sortBy,
      sortDirection,
    },
  });
};

export const leadPartnerUpdateNotes = ({ referralId, note }) => {
  return interceptor.put(
    `${apiUrl}/lead_partners/referral/update-notes/${referralId}`,
    { note }
  );
};

export const leadPartnerGetResource = () => {
  return interceptor.get(`${apiUrl}/lead_partners/resources`);
};

export const getLeadPartnerResourceItemStatistics = (
  itemId,
  startDate,
  endDate
) => {
  return interceptor.get(
    `${apiUrl}/lead_partners/statistics/resource-items?itemId=${itemId}&startDate=${startDate}&endDate=${endDate}`
  );
};

export const getLeadPartnerResourceItemEmailStatistics = (
  startDate,
  endDate,
  itemId = ''
) => {
  return interceptor.get(
    `${apiUrl}/lead_partners/statistics/resource-item-email-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}`
  );
};

export const getLeadPartnerResourceItemPhoneStatistics = (
  startDate,
  endDate,
  itemId = ''
) => {
  return interceptor.get(
    `${apiUrl}/lead_partners/statistics/resource-item-phone-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}`
  );
};

export const getLeadPartnerBenefitViewedStatistics = (
  startDate,
  endDate,
  itemId = ''
) => {
  return interceptor.get(
    `${apiUrl}/lead_partners/statistics/benefits-viewed?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}`
  );
};

export const getLeadPartnerBenefitOutboundClicksStatistics = (
  startDate,
  endDate,
  itemId = ''
) => {
  return interceptor.get(
    `${apiUrl}/lead_partners/statistics/benefit-outbound-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}`
  );
};

export const getLeadPartnerBenefitEmailStatistics = (
  startDate,
  endDate,
  itemId = ''
) => {
  return interceptor.get(
    `${apiUrl}/lead_partners/statistics/email-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}`
  );
};

export const getLeadPartnerBenefitPhoneStatistics = (
  startDate,
  endDate,
  itemId = ''
) => {
  return interceptor.get(
    `${apiUrl}/lead_partners/statistics/phone-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}`
  );
};

export const getLeadPartnerProfile = () => {
  return interceptor.get(`${apiUrl}/lead_partners/users/profile`);
};

export const editorsGetAllBenefits = (page, keyword = '') => {
  return interceptor.get(
    `${apiUrl}/lead_partners/benefits?page=${page}&keyword=${keyword}`
  );
};

export const editorsGetBenefitCategories = () => {
  return interceptor.get(`${apiUrl}/lead_partners/benefits/category`);
};

export const editorsCreateBenefit = (benefit) => {
  return interceptor.post(`${apiUrl}/lead_partners/benefits`, benefit);
};

export const editorsDeleteBenefit = (benefitID) => {
  return interceptor.delete(`${apiUrl}/lead_partners/benefits/${benefitID}`);
};

export const editorsUpdateBenefit = (benefit) => {
  return interceptor.put(
    `${apiUrl}/lead_partners/benefits/${benefit._id}`,
    benefit
  );
};

export const partnersSetUp2Factor = () => {
  return interceptor.post(`${apiUrl}/lead_partners/two-factor/set-up-2fa`);
};

export const partnersUpdate2Factor = (user, enable, token) => {
  return interceptor.put(
    `${apiUrl}/lead_partners/two-factor/update-2fa?enable=${enable}`,
    { ...user, token }
  );
};

export const leadPartnersGetUsers = (
  page = 1,
  startDate,
  endDate,
  keyword = '',
  limit = 25,
  sortBy = 'createdAt',
  sortDirection = 'desc'
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(`${apiUrl}/lead_partners/users`, {
    params: {
      page,
      startDate,
      endDate,
      keyword,
      limit,
      sortBy,
      sortDirection,
    },
  });
};

export const partnersSendInviteEmails = (shareLink, emails) => {
  return interceptor.post(`${apiUrl}/lead_partners/users/send-invites`, {
    shareLink,
    emails,
  });
};

export const leadPartnersGetClosedCases = (
  startDate,
  endDate
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(`${apiUrl}/lead_partners/users/closed-cases`, {
    params: {
      startDate,
      endDate,
    },
  });
};

export const leadPartnerExportReferrals = (
  startDate = '',
  endDate = '',
  filterValues = [],
  searchKeywords
) => {
  return interceptor.get(`${apiUrl}/lead_partners/export/referrals`, {
    params: {
      startDate,
      endDate,
      filterValues: filterValues.join(','),
      searchKeywords,
    },
    responseType: 'blob',
    timeout: 30000,
  });
};

export const leadPartnerExportUsers = (
  startDate = '',
  endDate = '',
  searchKeywords
) => {
  return interceptor.get(`${apiUrl}/lead_partners/export/users`, {
    params: {
      startDate,
      endDate,
      searchKeywords,
    },
    responseType: 'blob',
    timeout: 30000,
  });
};
